import { useSearchParams } from "react-router-dom";
import { STATUS_MAP } from "../../constants";
import ConsentView from "../components/ConsentView";
import StatusFeedbackView from "../components/StatusFeedbackView";
import { useSignzyConsent } from "../hooks/useSignzyConsent";
import { useMemo } from "react";
import { buildSignzy } from "../../config/signzy.build";

export default function SignzyStatusPage() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('q') || 'failed';
  const { service } = useMemo(() => buildSignzy(), []);
  const { submitConsent, isLoading, isError } = useSignzyConsent(service);

  if (!(status in STATUS_MAP)) {
    return (
      <ConsentView
        onSubmit={() => submitConsent(status)}
        isLoading={isLoading}
        isError={isError}
      />
    );
  }

  const currentView = STATUS_MAP[status] || STATUS_MAP.failed;

  return <StatusFeedbackView currentView={currentView} />;
}